import './landing.scss';
import 'bootstrap';
import IMask from 'imask';
import $ from 'jquery';
import Vue from 'vue/dist/vue.esm.js'
import vueSelect from 'vue-select'
import debounce from 'lodash.debounce';

window.IMask = IMask;
window.$ = window.jQuery = $;
window.Vue = Vue;
window.debounce = debounce;

Vue.component('v-select', vueSelect)
